import styled from 'styled-components';

export const SRowContainer = styled.div<{ diameter: number }>`
  display: flex;
  position: relative;
  height: ${({ diameter }) => `${diameter}px`};
  min-width: ${({ diameter }) => `${diameter}px`};
  * + * {
    margin-left: -2.35rem;
  }
`;
